var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"450px","width":"90%"},attrs:{"id":"echart-pie"}})
}
var staticRenderFns = []

export { render, staticRenderFns }